import React from 'react';
import { motion } from 'framer-motion';
export function Guarantee() {
  return <section className="py-20 px-4 bg-white" data-id="element-95" data-mp="20ld6dh4fo9lm">
      <div className="max-w-3xl mx-auto" data-id="element-96" data-mp="20mef3exz8k06">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-crema p-10 md:p-16 rounded-3xl border-2 border-dorado/20 shadow-lg text-center relative overflow-hidden" data-id="element-97" data-mp="24n85ceyw6aw8">
          {/* Decorative background circle */}
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-dorado/5 rounded-full blur-3xl pointer-events-none" data-id="element-98" data-mp="2oaxra5k5dgxj" />

          <div className="text-6xl mb-6 relative z-10" data-id="element-99" data-mp="2sbhjqvtrzwdc">🛡️</div>

          <h2 className="text-3xl md:text-4xl font-bold text-oscuro mb-8 relative z-10" data-id="element-100" data-mp="txobjw10cz6u">
            Garantía 7 días sin preguntas
          </h2>

          <div className="text-lg md:text-xl text-gray-700 space-y-4 mb-8 relative z-10 leading-relaxed" data-id="element-101" data-mp="xz1kwg3b7kii">
            <p data-id="element-102" data-mp="3snj9yttawmhd">Abre los 12 Tomos. Revisa los 6 Bonus.</p>
            <p data-id="element-103" data-mp="3nuggsmsfrf1p">Usa los Ebooks Élite en tu clase.</p>
            <p className="font-bold text-terracota mt-6" data-id="element-104" data-mp="3nsvicm303byk">
              Si no es lo que esperabas →<br data-id="element-105" data-mp="3ivwtahy71v78" />
              100% de devolución.
            </p>
            <p className="font-medium" data-id="element-106" data-mp="3dxljg77wfkp0">
              Sin preguntas. Sin formularios.
              <br data-id="element-107" data-mp="ff6gnk83wjwk" />
              Sin drama.
            </p>
          </div>

          <p className="text-sm text-gray-400 font-medium relative z-10 uppercase tracking-wider" data-id="element-108" data-mp="ag39nu8kg3ly">
            Tasa de devoluciones menor al 2%
          </p>
        </motion.div>
      </div>
    </section>;
}